import React from "react";
import LightGallery from "lightgallery/react";
import lgZoom from "lightgallery/plugins/zoom";
import lgVideo from "lightgallery/plugins/video";
import lgShare from "lightgallery/plugins/share";
import lgThumbnail from "lightgallery/plugins/thumbnail";

const GiftSetGallery = () => {
  /*eslint-disable */
  return (
    <section id="gift-set-gallery" className="gallery">
      <h1 className="title">Khay Quà Tết</h1>
      <LightGallery
        download={false}
        plugins={[lgZoom, lgVideo, lgShare, lgThumbnail]}
        mode="lg-fade"
      >
        {/* 1 */}
        <a
          className="gallery-item"
          data-src="images/products/gift-set/KQ01 sp.png"
          data-sub-html="<h1>Khay quà KQ01</h1><h2>195.000 đồng</h2>"
        >
          <img
            className="img-responsive"
            src="images/products/gift-set/KQ01.png"
            width="300"
            height="300"
          />
        </a>

        {/* 2 */}
        <a
          className="gallery-item"
          data-src="images/products/gift-set/KQ02 sp.png"
          data-sub-html="<h1>Khay quà KQ02</h1><h2>225.000 đồng</h2>"
        >
          <img
            className="img-responsive"
            src="images/products/gift-set/KQ02.png"
            width="300"
            height="300"
          />
        </a>

        {/* 3 */}
        <a
          className="gallery-item"
          data-src="images/products/gift-set/KQ03 sp.png"
          data-sub-html="<h1>Khay quà KQ03</h1><h2>329.000 đồng</h2>"
        >
          <img
            className="img-responsive"
            src="images/products/gift-set/KQ03.png"
            width="300"
            height="300"
          />
        </a>

        {/* 4 */}
        <a
          className="gallery-item"
          data-src="images/products/gift-set/KQ04 sp.png"
          data-sub-html="<h1>Khay quà KQ4</h1><h2>319.000 đồng</h2>"
        >
          <img
            className="img-responsive"
            src="images/products/gift-set/KQ04.png"
            width="300"
            height="300"
          />
        </a>

        {/* 5 */}
        <a
          className="gallery-item"
          data-src="images/products/gift-set/KQ05 sp.png"
          data-sub-html="<h1>Khay quà KQ05</h1><h2>295.000 đồng</h2>"
        >
          <img
            className="img-responsive"
            src="images/products/gift-set/KQ05.png"
            width="300"
            height="300"
          />
        </a>

        {/* 6 */}
        <a
          className="gallery-item"
          data-src="images/products/gift-set/KQ06 sp.png"
          data-sub-html="<h1>Khay quà KQ06</h1><h2>295.000 đồng</h2>"
        >
          <img
            className="img-responsive"
            src="images/products/gift-set/KQ06.png"
            width="300"
            height="300"
          />
        </a>

        {/* 7 */}
        <a
          className="gallery-item"
          data-src="images/products/gift-set/KQ07 sp.png"
          data-sub-html="<h1>Khay quà KQ07</h1><h2>215.000 đồng</h2>"
        >
          <img
            className="img-responsive"
            src="images/products/gift-set/KQ07.png"
            width="300"
            height="300"
          />
        </a>

        {/* 8 */}
        <a
          className="gallery-item"
          data-src="images/products/gift-set/KQ08 sp.png"
          data-sub-html="<h1>Khay quà KQ07</h1><h2>369.000 đồng</h2>"
        >
          <img
            className="img-responsive"
            src="images/products/gift-set/KQ08.png"
            width="300"
            height="300"
          />
        </a>

        {/* 9 */}
        <a
          className="gallery-item"
          data-src="images/products/gift-set/KQ09 sp.png"
          data-sub-html="<h1>Khay quà KQ07</h1><h2>369.000 đồng</h2>"
        >
          <img
            className="img-responsive"
            src="images/products/gift-set/KQ09.png"
            width="300"
            height="300"
          />
        </a>
      </LightGallery>
    </section>
  );
};

export default GiftSetGallery;
